/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Google_HintInputs */

const cs_settings_calendar_google_hint = /** @type {(inputs: Settings_Calendar_Google_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojte jednou pro přihlášení Google, synchronizaci kalendáře a budoucí export na YouTube. Stačí osobní @gmail.com.`)
};

const en_settings_calendar_google_hint = /** @type {(inputs: Settings_Calendar_Google_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect once for Google sign-in, Calendar sync, and future YouTube export. Personal @gmail.com is fine.`)
};

/**
* | output |
* | --- |
* | "Connect once for Google sign-in, Calendar sync, and future YouTube export. Personal @gmail.com is fine." |
*
* @param {Settings_Calendar_Google_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_google_hint = /** @type {((inputs?: Settings_Calendar_Google_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Google_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_google_hint(inputs)
	return cs_settings_calendar_google_hint(inputs)
});